import { isDealersShopUri, uriIncludesVertical, isMoreFromSeller } from './uriUtils';
import { TYPES } from '../constants/favoritesConstants';

/**
 * @param uri - uri string
 * @param isOnlyFetching - If true will return an array of types that count as follows
 */

export function getFollowTypeFromUri(uri: string): typeof TYPES.DEALER | typeof TYPES.SEARCH;
export function getFollowTypeFromUri(
    uri: string,
    isOnlyFetching: true
): [typeof TYPES.DEALER] | [typeof TYPES.SEARCH, typeof TYPES.USER_PREFERENCE];
export function getFollowTypeFromUri(
    uri: string,
    isOnlyFetching: false
): typeof TYPES.DEALER | typeof TYPES.SEARCH;
export function getFollowTypeFromUri(
    uri: string = '',
    isOnlyFetching: boolean = false
):
    | typeof TYPES.DEALER
    | typeof TYPES.SEARCH
    | [typeof TYPES.DEALER]
    | [typeof TYPES.SEARCH, typeof TYPES.USER_PREFERENCE] {
    const isDealer = isDealersShopUri(uri) && !uriIncludesVertical(uri);
    if (isDealer || isMoreFromSeller(uri)) {
        return isOnlyFetching ? [TYPES.DEALER] : TYPES.DEALER;
    }

    return isOnlyFetching ? [TYPES.SEARCH, TYPES.USER_PREFERENCE] : TYPES.SEARCH;
}
